<div [ngClass]="{'period-bundles-table-wrapper': !isBundleView}" data-cy="period-bundles-table-wrapper">
  @if (!isBundleView) {
    <div class="period-bundles-table-header-wrapper">
      <app-info-chart [configuration]="periodTotalAmountInfoChart()"
        [elementClickManually]="$safeNavigationMigration(state?.selectedLine)"
        [infoChartElementClosed]="$safeNavigationMigration(state?.infoChartElementClosed)"
        [elementMouseHover]="state.mouseHoverLineIdentifier"
        (mouseHoverLineTable)="mouseHoverLine($event)"
      (identifier)="openLine($event)"></app-info-chart>
      <div class="period-bundles-table-spec-wrapper" data-cy="period-bundles-table-spec-wrapper">
        <app-card [baseCypressTag]="PERIOD_CRITERIA_CYPRESS_TAG"
          [listGroups]="periodCriteriaInfo"
        [title]="PERIOD_CRITERIA_TITLE"></app-card>
      </div>
    </div>
  }

  <app-table (selectedLine)="loadDetailData($event)"
    (mouseHoverLine)="mouseHoverHandler($event)"
    (mouseleave)="mouseHoverHandler($event)"
    [accordionLineTemplate]="accordionLineTemplate"
    [tableData]="tableDataInfo"
  [tableName]="TABLE_NAME"></app-table>

  <ng-template #accordionLineTemplate>
    <app-bundle-information-table (updateBundleDetail)="updateBundleDetail($event)"
      (updatePeriodDetail)="updatePeriodDetail($event)"
      (updateInfoChart)="updateInfoChartClose($event)"
      [bundleCriteria]="state.selectedLineCriteria"
      [bundleData]="state.selectedLineData"
      [bundleClosedInformation]="state.selectedLineClosedInformation"
      [bundleSentInformation]="state.selectedLineSentInformation"
    [bundlePositionsData]="accordionContext"></app-bundle-information-table>
  </ng-template>

  <ng-template #bundlesTotalSettlementsTemplate let-totalSettlements="totalSettlements">
    <div class="total-settlements-wrapper">
      <div class="total-settlements-count" data-cy="total-settlements-count">{{totalSettlements}}</div>
      <div class="total-settlements-label" data-cy="total-settlements-label">Total</div>
    </div>
  </ng-template>


  <ng-template #bundlesProgressBarLinesTemplate let-progressBar="progressBar">
    <div class="progress-bar-wrapper">
      @if (progressBar.percentage != null) {
        <div class="progress-bar-line" [ngClass]="getStyleForBundlingSettingsOpen()">
          <app-progress-bar-line
          [progressBar]="progressBar"></app-progress-bar-line>
        </div>
      }
      <div class="progress-bar-line-percentage" [ngClass]="getStyleForBundlingSettingsOpen()"
      data-cy="progress-bar-line-text">{{percentageLabel($safeNavigationMigration(progressBar?.percentage))}}</div>
    </div>
  </ng-template>

  <ng-template #bundlesProgressBarSquaresTemplate let-lines="lines" let-squares="squares">
    <div class="progress-bar-wrapper">
      @if (showBundlesProgressBarSquaresTemplate(squares.totalSquares)) {
        <div class="progress-bar-line-square" [ngClass]="getStyleForBundlingSettingsOpen()">
          <app-progress-bar-square
          [squares]="squares"></app-progress-bar-square>
        </div>
      }
      <div class="progress-bar-squares-lines" data-cy="progress-bar-squares-lines-text">{{lines}}</div>
    </div>
  </ng-template>

  <ng-template #statusInformationTemplate let-bundleInformation="bundleInformation">
    <app-copy-paste
      [copyText]="$safeNavigationMigration(bundleInformation?.status?.name)"
      [backgroundColor]="backgroundColorHover">
      <div class="status-wrapper">
        @if (displayStatusTooltip($safeNavigationMigration(bundleInformation?.status))) {
          <app-tooltip [dynamic]="false" [message]="statusCloseInformationTemplate"
            tooltipCustomClass="status-closed-information-tooltip">
            <div class="status-circle" data-cy="status-circle" [ngClass]="$safeNavigationMigration(bundleInformation?.status?.code)"></div>
          </app-tooltip>
        } @else {
          <div class="status-circle" data-cy="status-circle" [ngClass]="$safeNavigationMigration(bundleInformation?.status?.code)"></div>
        }

        <ng-template #statusWithoutTooltip>
          <div class="status-circle" data-cy="status-circle" [ngClass]="$safeNavigationMigration(bundleInformation?.status?.code)"></div>
        </ng-template>

        <div class="status-text-wrapper">
          <app-tooltip [message]="$safeNavigationMigration(bundleInformation?.status?.name)">
            <span class="status-text" data-cy="status-text">{{bundleInformation?.status?.name}}</span>
          </app-tooltip>
        </div>

        <ng-template #statusCloseInformationTemplate>
          <p>{{bundleInformation?.closedTooltip}}</p>
        </ng-template>

      </div>
    </app-copy-paste>
  </ng-template>
</div>
